import { tracking } from '@podiumhq/tracking';

import env from 'env';
import {
  submitConversionToImpact,
  submitConversionToRokt,
} from 'lib/conversionTracking';
import { addErrorToDatadog } from 'lib/datadogError';
import { createCookie, createTokenCookie } from 'lib/getIdToken';

export const getOnTrialCreateErrorMessage = (error, isStripeError) => {
  const errorStringified = JSON.stringify(error);
  let customError = '';
  let reason = '';

  switch (true) {
    case isStripeError:
      customError = error?.message;
      break;
    case errorStringified.includes('active_vpn'):
      customError = 'Please turn off your VPN to start your trial.';
      reason = 'active_vpn';
      break;
    case errorStringified.includes('fingerprint_id'):
      customError = 'Please turn off your ad blocker.';
      reason = 'ad_blocker';
      break;
    default:
      break;
  }

  return {
    customError,
    errorMessageForTracking: `startTrial: ${errorStringified}`,
    reason,
  };
};

export const setTokenCookies = (idToken, refreshToken, noPasswordSet) => {
  try {
    const hostname = window.location.hostname;
    document.cookie = createTokenCookie({ hostname, tokenValue: idToken });
    document.cookie = createCookie({
      cookieName: 'refreshToken',
      cookieValue: refreshToken,
      hostname,
    });

    if (noPasswordSet) {
      document.cookie = createCookie({
        cookieName: 'freeTrialLogin',
        cookieValue: true,
        hostname,
      });
    }
  } catch (errors) {
    console.log('error setting cookies: ', errors);
    addErrorToDatadog(new Error(errors));
  }
};

export const redirectToEducation = (
  locationUid = '',
  isGoogleLogin = false
) => {
  const onboardingUrl = `${env.KAZAAM_URL}/onboarding/education?locationUid=${locationUid}`;

  if (isGoogleLogin) {
    const loginUrl = `${env.ACCOUNTS_URL}/?redirect_uri=${encodeURI(
      onboardingUrl
    )}`;
    window.top.location = loginUrl;
  } else {
    window.top.location = onboardingUrl;
  }
};

export const onSuccessfulCreateTrial = ({
  email,
  firstName,
  idToken,
  isFreeTrialStart,
  isGoogleLogin,
  lastName,
  locationUid,
  noPasswordSet,
  organizationUid,
  plan,
  refreshToken,
  userUid,
} = {}) => {
  if (!isGoogleLogin) {
    setTokenCookies(idToken, refreshToken, noPasswordSet);
  }
  tracking.setUserUid(userUid);
  tracking.setGroup('organizationUid', organizationUid);
  tracking.setGroup('locationUid', locationUid);

  if (isFreeTrialStart) {
    const now = new Date();
    tracking.setUserProperties({ freeTrialStart: now.toUTCString() });
  }

  submitConversionToRokt({
    email,
    firstName,
    lastName,
    plan,
    userUid,
  });
  submitConversionToImpact(userUid, organizationUid);
};

export const setTrialError = ({
  error,
  errorEventToTrack = 'trials.startTrial.error',
  isStripeError = false,
  setCustomMessage,
  setErrorReason,
  shouldDisplayError,
  trackEvent,
} = {}) => {
  const { customError, errorMessageForTracking, reason } =
    getOnTrialCreateErrorMessage(error, isStripeError);

  setCustomMessage && setCustomMessage(customError);
  setErrorReason && setErrorReason(reason);
  shouldDisplayError && shouldDisplayError(true);

  trackEvent &&
    trackEvent(errorEventToTrack, { error: errorMessageForTracking });

  if (!isStripeError) {
    addErrorToDatadog(errorMessageForTracking);
  }
};

export const handleCloseTrialModal = () =>
  window?.parent?.postMessage('hideCheckoutModal', '*');

export const isEmailExistsError = (error) =>
  error ? JSON.stringify(error)?.includes('email_already_exists') : false;

export const isSourceMobile = (source) => source === 'mobile';
